import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AnimatedSection, fadeUp } from "@/components/motion";
import { IMAGES } from "./images";

const products = [
  { title: "Unstitched Dress Materials", image: IMAGES.product1, span: "col-span-2 row-span-2" },
  { title: "Printed Fabrics", image: IMAGES.fabric_colors, span: "col-span-1" },
  { title: "Embroidered Textiles", image: IMAGES.craftsmanship, span: "col-span-1" },
  { title: "Custom Developments", image: IMAGES.product2, span: "col-span-1" },
  { title: "Ready Garments", image: IMAGES.factory, span: "col-span-1" },
];

export const FeaturedProductsSection = () => (
  <AnimatedSection id="products" className="py-24 lg:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div variants={fadeUp} className="mb-16">
        <p className="text-xs font-sans uppercase tracking-[0.2em] text-[#C5A059] mb-4">Portfolio</p>
        <h2 className="text-4xl md:text-5xl font-serif tracking-tight text-foreground mb-4">
          Our Product Portfolio
        </h2>
        <p className="text-base font-sans text-muted-foreground max-w-xl">
          A curated range of fabrics and garments designed for diverse markets.
        </p>
      </motion.div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-[200px] lg:auto-rows-[250px]" data-testid="products-grid">
        {products.map((p) => (
          <motion.div
            key={p.title}
            variants={fadeUp}
            className={`product-card-hover relative group ${p.span}`}
          >
            <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-500 flex items-end p-6">
              <h3 className="font-serif text-white text-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500 translate-y-2 group-hover:translate-y-0">
                {p.title}
              </h3>
            </div>
          </motion.div>
        ))}
      </div>
      <motion.div variants={fadeUp} className="mt-10 text-center">
        <Link to="/products">
          <Button
            data-testid="view-all-products-btn"
            variant="outline"
            className="rounded-none px-8 py-5 text-xs uppercase tracking-[0.15em] font-sans border-foreground text-foreground hover:bg-foreground hover:text-white"
          >
            View All Products <ArrowRight size={14} className="ml-2" />
          </Button>
        </Link>
      </motion.div>
    </div>
  </AnimatedSection>
);
